import { render, staticRenderFns } from "./ActionDelete.vue?vue&type=template&id=0485f6d8&scoped=true&"
import script from "./ActionDelete.vue?vue&type=script&lang=js&"
export * from "./ActionDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0485f6d8",
  null
  
)

export default component.exports